import styled from 'styled-components'

export const Wrapper = styled.div`
	margin-top: 64px;
	width: 100%;
	height: 100%;
	max-width: 600px;
	overflow: hidden;
	pointer-events: none;

	@media only screen and (max-width: 1010px) and (min-width: 769px) {
		padding: 0 66px;
		margin: 0 auto;
	}
`
